import { api } from "@/lib/api";
import type { PublicWarningsSnapshot } from "@/lib/api/types";

/** The latest weather-warning snapshot is global, not dashboard-specific. */
export const riskPictureWarningSetsKey = () => ["riskPictureWarningSets"] as const;

/**
 * Reads an HTTP response status without depending on a concrete Axios error instance.
 * This allows `fetchRiskPictureWarningSets` to treat only a missing snapshot as empty.
 */
export const weatherWarningsResponseStatus = (error: unknown): unknown => {
  if (typeof error !== "object" || error === null || !("response" in error)) {
    return undefined;
  }
  const response = error.response;
  if (typeof response !== "object" || response === null || !("status" in response)) {
    return undefined;
  }
  return response.status;
};

/** Returns null when no snapshot has been published yet. */
export async function fetchRiskPictureWarningSets(): Promise<PublicWarningsSnapshot | null> {
  try {
    const { data } = await api.data.getPublicWarningsSnapshot();
    return data;
  } catch (error) {
    if (weatherWarningsResponseStatus(error) === 404) return null;
    throw error;
  }
}
